var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rc-qr-scan"},[_c('div',{staticClass:"rc-container"},[_c('div',{staticClass:"code-container"},[_c('div',{staticClass:"code"},[_c('div',{staticClass:"rc-title"},[_c('h2',{domProps:{"innerHTML":_vm._s(
              _vm.$t('qr-scan-receptionist-page.title', {
                split: '<br>'
              })
            )}})]),_c('br'),_c('div',{staticClass:"rc-notify",staticStyle:{"width":"100%"},domProps:{"innerHTML":_vm._s(
            _vm.$t(
              'qr-scan-receptionist-page.description',
              { split: '/' },
              { br: '<br>' }
            )
          )}}),_c('div',{staticClass:"code-info"},[_c('div',{staticClass:"qr-code"},[_c('qrcode-scan',{attrs:{"type":_vm.QRSCAN_RECEPTION_CHECKIN_ACTION,"formatOfData":_vm.CHECKIN_RECEPTION_DATA_FORMAT}})],1),_c('div',{staticClass:"widget-button py-5 text-center"},[_c('router-link',{attrs:{"tag":"button","to":_vm.pathHome + '/top'}},[_c('v-btn',{staticClass:"btn-back",attrs:{"depressed":"","outlined":"","color":"#e8320e"}},[_vm._v(_vm._s(_vm.$t('scan-success-page.btn-back', { split: '/' })))])],1)],1)])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }